import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const BlockchainDevelopment = () => {
  useEffect(() => {
    // Scroll-based navigation highlighting
    const sections = document.querySelectorAll(".tab-data[id]");
    const navLinks = document.querySelectorAll(".nav-selector a");

    const navHighlighter = () => {
      let scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop =
          current.getBoundingClientRect().top + window.pageYOffset - 50;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          navLinks.forEach((link) => {
            link.parentElement.classList.remove("active");
            if (link.getAttribute("href") === `#${sectionId}`) {
              link.parentElement.classList.add("active");
            }
          });
        }
      });
    };

    window.addEventListener("scroll", navHighlighter);
    return () => window.removeEventListener("scroll", navHighlighter);
  }, []);

  return (
    <div className="blockchain-development-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.3s">
              Blockchain Development
            </h1>
          </div>
        </div>
      </section>

      <section className="top-services-section">
        <div className="container">
          <div className="title">
            <h2 className="wow fadeInUp">
              Harness the{" "}
              <span className="gradient-text">Power of Decentralization </span>
              :<br />
              Expert Blockchain Development Services
            </h2>
            <h3 className="wow fadeInUp">How we work</h3>
            <p className="wow fadeInUp">
              Slash Star is a Top blockchain development company in India, we
              specialize in crafting tailored blockchain solutions that empower
              your business to thrive in the digital landscape. Our team of
              experts focuses on delivering secure, scalable, and efficient
              decentralized applications, seamlessly integrated with your
              existing systems. Trust Slash Star to navigate the future of
              blockchain technology and unlock new opportunities for growth.
            </p>
          </div>
          <div className="row flex-start wow fadeInUp">
            <div className="col col-4">
              <div className="box">
                <span>01</span>
                <h3>Project ideation</h3>
                <p>
                  We begin by conducting a thorough assessment of your unique
                  business needs, objectives, and existing infrastructure to
                  identify the potential impact and benefits of implementing
                  blockchain technology.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>02</span>
                <h3>Solution Design</h3>
                <p>
                  Our team of experts designs a bespoke blockchain solution
                  tailored to your specific requirements, ensuring seamless
                  integration and optimal performance within your existing
                  systems.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>03</span>
                <h3>Development</h3>
                <p>
                  Our skilled blockchain developers leverage the latest tools,
                  frameworks, and platforms to build secure, scalable, and
                  efficient decentralized applications that meet your business
                  goals.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>04</span>
                <h3>Quality Assurance</h3>
                <p>
                  Rigorous testing and quality assurance processes are conducted
                  to guarantee that your blockchain solution is bug-free,
                  secure, and performs as intended in all scenarios.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>05</span>
                <h3>Deployment</h3>
                <p>
                  We assist in the seamless deployment of your blockchain
                  solution, ensuring smooth integration with your existing
                  infrastructure and minimal disruption to your business
                  operations.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>06</span>
                <h3>Ongoing support</h3>
                <p>
                  Our commitment to your success extends beyond project
                  completion, offering reliable support and maintenance services
                  to ensure your blockchain solution remains up-to-date, secure,
                  and performs at its best.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tabs-section">
        <div className="container wow fadeInUp">
          <div className="row">
            <div className="col col-6 nav-selector">
              <div className="title-small">
                <span>SERVICES</span>
              </div>
              <ul>
                <li>
                  <a href="#section1">Blockchain Development</a>
                </li>
                <li>
                  <a href="#section2">Smart Contract Development</a>
                </li>
                <li>
                  <a href="#section3">Token Development</a>
                </li>
                <li>
                  <a href="#section4">NFT Development</a>
                </li>
                <li>
                  <a href="#section5">DeFi Solutions</a>
                </li>
              </ul>
            </div>
            <div className="col col-6">
              <div className="tab-data" id="section1">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/blockchain/block-chain-develop.webp"
                    alt="Blockchain Development"
                  />
                </div>
                <h3>Blockchain Development</h3>
                <p>
                  We create tailored blockchain solutions, including public and
                  private blockchain networks, smart contracts, and
                  decentralized applications (dApps), to meet your unique
                  business needs.
                </p>
              </div>
              <div className="tab-data" id="section2">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/blockchain/block-smart.webp"
                    alt="Blockchain Smart"
                  />
                </div>
                <h3>Smart Contract Development</h3>
                <p>
                  Our developers specialize in designing, coding, and deploying
                  secure and efficient smart contracts for various platforms
                  such as Ethereum, Binance Smart Chain, and Cardano.
                </p>
              </div>
              <div className="tab-data" id="section3">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/blockchain/block-token.webp"
                    alt="Blockchain Token"
                  />
                </div>
                <h3>Cryptocurrency & Token Development</h3>
                <p>
                  We help you create custom cryptocurrencies or tokens based on
                  popular blockchain protocols, such as ERC-20, BEP-20, and
                  ERC-721, tailored to your project requirements.
                </p>
              </div>
              <div className="tab-data" id="section4">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/blockchain/block-nft.webp"
                    alt="Blockchain NFT"
                  />
                </div>
                <h3>NFT Development</h3>
                <p>
                  We create unique NFT platforms and marketplaces, allowing you
                  to tokenize digital assets, facilitate secure transactions,
                  and capitalize on the growing NFT ecosystem.
                </p>
              </div>
              <div className="tab-data" id="section5">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/blockchain/block-defi.webp"
                    alt="Blockchain Defi"
                  />
                </div>
                <h3>DeFi Solutions</h3>
                <p>
                  Our team develops innovative DeFi solutions, including
                  decentralized exchanges (DEX), lending platforms, and yield
                  farming applications, to help you capitalize on the growing
                  DeFi market.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="technology-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Technology</span>
          </div>
          <div className="title">
            <h2>
              Empowering Your Business with <br />
              Our <span className="gradient-text">Tech Savvy Stack</span>
            </h2>
          </div>
          <div className="flex-start">
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-ethereum.svg"
                  alt="ethereum"
                />
              </i>
              <span>Ethereum</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-bnb-smart-chain.svg"
                  alt="smart chain"
                />
              </i>
              <span>Binance Smart Chain</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-polygon-matic.svg"
                  alt="polygon matic"
                />
              </i>
              <span>Polygon</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-polkadot.svg"
                  alt="polkadot"
                />
              </i>
              <span>Polkadot</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-cardano.svg" alt="cardano" />
              </i>
              <span>Cardano</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-solidity.svg"
                  alt="solidity"
                />
              </i>
              <span>Solidity</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-python.svg" alt="python" />
              </i>
              <span>Python</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-node-js.svg" alt="node" />
              </i>
              <span>NodeJS</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-ipfs.svg" alt="ipfs" />
              </i>
              <span>IPFS</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-infura.svg" alt="infura" />
              </i>
              <span>Infura</span>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Why Us</span>
          </div>
          <div className="title">
            <h2>
              The Benefits of <span className="gradient-text">Partnering</span>{" "}
              with Us
            </h2>
          </div>
          {/* Desktop */}
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>Industry-Leading Expertise</h3>
                <p>
                  Our team of experienced blockchain developers possesses a deep
                  understanding of the latest tools, platforms, and best
                  practices, ensuring that your project is in the hands of true
                  experts.
                </p>
              </div>
              <div>
                <h3>Agile Development Process</h3>
                <p>
                  Our flexible and adaptive approach, grounded in Agile
                  methodologies, enables efficient project execution, seamless
                  collaboration, and the ability to adapt to changing
                  requirements throughout the development process.
                </p>
              </div>
              <div>
                <h3>Security and Compliance</h3>
                <p>
                  We prioritize security and data integrity in all our
                  blockchain development projects, implementing rigorous
                  measures to ensure that your solution adheres to industry
                  standards and regulatory requirements.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Cutting-Edge Technology</h3>
                <p>
                  We stay up-to-date with the latest advancements in blockchain
                  technology, ensuring that your project benefits from
                  state-of-the-art tools, frameworks, and platforms.
                </p>
              </div>
              <div>
                <h3>Bespoke Solutions</h3>
                <p>
                  We craft tailored blockchain solutions that address your
                  specific business needs and objectives, enabling you to
                  harness the full potential of distributed ledger technology.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>Proven Track Record</h3>
                <p>
                  Our successful history of delivering transformative blockchain
                  solutions demonstrates our commitment to quality, innovation,
                  and customer satisfaction.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>Industry-Leading Expertise</h3>
              <p>
                Our team of experienced blockchain developers possesses a deep
                understanding of the latest tools, platforms, and best
                practices, ensuring that your project is in the hands of true
                experts.
              </p>
            </div>
            <div>
              <h3>Agile Development Process</h3>
              <p>
                Our flexible and adaptive approach, grounded in Agile
                methodologies, enables efficient project execution, seamless
                collaboration, and the ability to adapt to changing requirements
                throughout the development process.
              </p>
            </div>
            <div>
              <h3>Security and Compliance</h3>
              <p>
                We prioritize security and data integrity in all our blockchain
                development projects, implementing rigorous measures to ensure
                that your solution adheres to industry standards and regulatory
                requirements.
              </p>
            </div>
            <div>
              <h3>Cutting-Edge Technology</h3>
              <p>
                We stay up-to-date with the latest advancements in blockchain
                technology, ensuring that your project benefits from
                state-of-the-art tools, frameworks, and platforms.
              </p>
            </div>
            <div>
              <h3>Bespoke Solutions</h3>
              <p>
                We craft tailored blockchain solutions that address your
                specific business needs and objectives, enabling you to harness
                the full potential of distributed ledger technology.
              </p>
            </div>
            <div>
              <h3>Proven Track Record</h3>
              <p>
                Our successful history of delivering transformative blockchain
                solutions demonstrates our commitment to quality, innovation,
                and customer satisfaction.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-2" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-3" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlockchainDevelopment;
